// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Deletes an existing file from a return order.
 *
 * @param returnOrderKey - The key of the return order.
 * @param fileKey - The key of the file.
 */
export async function deleteReturnOrderFile(
  returnOrderKey: string,
  fileKey: string
) {
  const path = `/v1/return-order/${returnOrderKey}/file/${fileKey}`;
  const response = await api.delete(path);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteReturnOrderFile',
    endpoint: path,
  });
}
